module.exports = __webpack_public_path__ + "img/maze_triangular_ca.19bdb304.svg";